import { render, staticRenderFns } from "./Wine.vue?vue&type=template&id=6ac2bd6a&"
import script from "./Wine.vue?vue&type=script&lang=js&"
export * from "./Wine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports